/**
 * Category name translations.
 * DB stores Swedish names. This maps slug → English name for .me domain.
 * Usage: translateCategory(slug, svName, locale)
 */

const EN_CATEGORIES: Record<string, string> = {
  'bromsanlaggning': 'Brake System',
  'karosseri': 'Body',
  'tandsystem': 'Ignition System',
  'koppling': 'Clutch',
  'fjadring-dampning': 'Suspension / Damping',
  'avgassystem': 'Exhaust System',
  'belysning': 'Lighting',
  'kylsystem': 'Cooling System',
  'torka-spola': 'Wipers / Washers',
  'styrning': 'Steering',
  'hjulupphangning': 'Wheel Suspension',
  'blandningsberedning': 'Fuel Mixture',
  'topplock': 'Cylinder Head',
  'luftberedning': 'Air Supply',
  'remmar': 'Belts',
  'hjuldrivning': 'Wheel Drive',
  'klimatanlaggning-ac': 'Air Conditioning',
  'varme-ventilation': 'Heating / Ventilation',
  'smorjning': 'Lubrication',
  'generator': 'Alternator',
  'motorstyrning': 'Engine Management',
  'startanordning': 'Starter System',
  'matarpump-bransle': 'Fuel Pump',
  'invandig-utrustning': 'Interior Equipment',
  'signalsystem': 'Signal System',
  'kraftoverforing': 'Powertrain',
  'standarddelar': 'Standard Parts',
  'motorupphangning': 'Engine Mounting',
  'avgasaterforing': 'Exhaust Gas Recirculation',
  'elektriska-universaldelar': 'Electrical Universal Parts',
  'lassystem': 'Lock System',
  'vevaxel': 'Crankshaft',
  'vevhus': 'Crankcase',
  'automatvaxellada': 'Automatic Transmission',
  'manuell-vaxellada': 'Manual Transmission',
  'komfortsystem': 'Comfort System',
  'kemiska-produkter': 'Chemical Products',
  'instrument': 'Instruments',
  'glodsystem': 'Glow System',
  'belysning-universal': 'Lighting, Universal',
  'hjul': 'Wheels',
  'tryckluftssystem': 'Compressed Air System',
  'avgassystemet-universal': 'Exhaust System, Universal',
  'stralkastarrengoring': 'Headlight Cleaning',
  'elsystemet': 'Electrical System',
  'forarhytt': "Driver's Cab",
  'tillbehor-universal': 'Accessories, Universal',
  'signalsystem-universal': 'Signal System, Universal',
  'sekundarluftsinblas': 'Secondary Air Injection',
  'sakerhetssystem': 'Safety System',
  'verktyg-universal': 'Tools, Universal',
  'karosseri-universal': 'Body, Universal',
  'draganordning-universal': 'Towing Device, Universal',
  'forgasare': 'Carburettor',
  'hybrid-eldrift': 'Hybrid / Electric Drive',
  'bransleforsorjning-universal': 'Fuel Supply, Universal',
  'bromssystem-universal': 'Brake System, Universal',
  'farthallare': 'Cruise Control',
  'verkstadsutrustning': 'Workshop Equipment',
  'komfortsystem-universal': 'Comfort System, Universal',
  'styrning-universal': 'Steering, Universal',
  'verktyg-fordonsspecifika': 'Vehicle-Specific Tools',
  'kupeutrustning-universal': 'Cabin Equipment, Universal',
  'eldrift': 'Electric Drive',
  'kommunikations-informationssystem': 'Communication / Information System',
  'batteri': 'Battery',
  'kraftuttag': 'Power Take-Off',
  'slapvagnskoppling': 'Trailer Coupling',
  'startgenerator': 'Starter Generator',
  'blandningsberedning-universal': 'Fuel Mixture, Universal',
  'esp': 'ESP',
  'hydrauliksystem': 'Hydraulic System',
  // Category sub-items
  'bromsbelagg': 'Brake Pads',
  'bromsskiva': 'Brake Discs',
  'bromsok': 'Brake Calipers',
  'bromsbackar-sats-parkeringsbroms': 'Parking Brake Shoes',
  'bromsvatskebehallarlock': 'Brake Fluid Reservoir Cap',
  'bromsslang': 'Brake Hose',
  'bromstromma': 'Brake Drum',
  'hjulcylinder': 'Wheel Cylinder',
  'ata-bromssystem': 'Brake System Misc.',
};

/**
 * Translate a category name based on slug and locale.
 * Returns English name if available, otherwise falls back to the Swedish name.
 */
export function translateCategory(slug: string, svName: string, locale: 'sv' | 'en'): string {
  if (locale === 'sv') return svName;
  return EN_CATEGORIES[slug] || svName;
}
